import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { GetPaymentResponse, GetQrPaymentResponse } from '../store/types';

@Injectable({ providedIn: 'root' })
export class PaymentService extends ApiService {
  findPayment(uuid: string) {
    return this.get<GetPaymentResponse>(`${API.getPayment}/${uuid}`);
  }

  userAccountBalance() {
    return this.get('API.userAccountBalance');
  }

  processPayment(uuid: string, code, accountNumber) {
    return this.post(`${API.processPayment}`, { body: { uuid, code, accountNumber } });
  }

  failedPayment(uuid: string, status: string) {
    return this.post(`${API.failedPayment}`, { body: { uuid, status } });
  }

  // NEW VERSION
  savePaymentAsQr(dto) {
    return this.post(API.savePaymentAsQr, { body: dto });
  }

  loadPaymentAsQr(id: string, ignoreScan: boolean = false) {
    return this.get<GetQrPaymentResponse>(`${API.loadPaymentAsQr}/${id}?ignoreScan=${ignoreScan}`);
  }

  cancelPaymentRequest(id) {
    return this.post(`${API.cancelPaymentRequest}`, { body: { idSolicitud: id } });
  }

  getUserFromBeneficiaryId(id) {
    return this.get(`${API.getUserFromBeneficiaryId}/${id}`);
  }

  sendPaymentRequestEmail(paylinkToken: string, email: string, message: string) {
    return this.post(API.sendPaymentEmail, {
      body: {
        email,
        paylinkToken,
        message
      }
    });
  }

  getPaymentRequestsByLink(linkToken: string, page?: number, limit?: number) {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append('page', page.toString());
    if (limit) queryParams.append('limit', limit.toString());

    const queryStr = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return this.get(`${API.getPaymentRequestsByLink}/${linkToken}${queryStr}`);
  }
}
